import * as React from "react";
import { useState, useEffect, createRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { IMapOptions } from "../interfaces/mapoptions";
import { IMapKitState } from "../interfaces/mapkit";
import { getMapKit, getMidPoint, mapKitToGoogleLatLngLit } from "../api/mapkit";
import { composePathPoi } from "../api/utility";
import { getPoiLatLng } from "../api/poisearch";
import { RootState } from "../reducers/index";
import { useAppSelector, useAppDispatch } from "../store/index";
import { setHalfway } from "../reducers/halfway";

// Apple mapkit version
const MapKitResults = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { adr1, adr2, poiname, travel } = useParams();
    const myRef = createRef<HTMLDivElement>();
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);
    const mapkitstate = useAppSelector<IMapKitState>((x: RootState) => x.mapkit);
    const poiList = useAppSelector((x: RootState) => x.poi.list);
    const [map, setMap] = useState(null);
    const [directions, setDirections] = useState(null);
    const [dirObjects, setDirObjects] = useState([]);

    // Loads the map and initializes the geocodes for each endpoint
    useEffect(() => {
        if (mapkitstate.isLoaded && mapkitstate.isInitialized) {
            const mapkit = getMapKit();
            const newmap = new mapkit.Map(myRef.current,
                { center: new mapkit.Coordinate(34.0522342, -118.2436849) });
            setMap(newmap);

            const geocoder = new mapkit.Geocoder({
                getsUserLocation: false
            });

            var myDirections = new mapkit.Directions();
            myDirections.route({
                origin: adr1,
                destination: adr2,
                transportType: mapkit.Directions.Transport.Automobile
            },
                function (error, data) {
                    //console.log("Route Results:");
                    //console.log(data);
                    setDirections(data);
                }
            );
        }
    }, [mapkitstate]);

    useEffect(() => {
        if (map && directions) {
            const mapkit = getMapKit();
            const routes = directions.routes;
            if (routes.length === 0) {
                return;
            }
            const route = routes[0];

            const pointA = new mapkit.MarkerAnnotation(directions.origin.coordinate, {
                draggable: false,
                selected: false,
                color: '#1ecf1a'
            });
            const pointB = new mapkit.MarkerAnnotation(directions.destination.coordinate, {
                draggable: false,
                selected: false
            });
            const midPointLatLng = getMidPoint(route);
            console.log(midPointLatLng);

            const startend = [pointA, pointB];
            map.addAnnotations(startend);

            map.addOverlay(route.polyline);
            const showlist = [route.polyline, pointA, pointB]
            map.showItems(showlist);

            // when we add the POI pins, we also need to show these objects
            // to ensure the bounds are set properly.
            setDirObjects(showlist);

            dispatch(setHalfway({
                latLng: midPointLatLng,
                startLatLng: mapKitToGoogleLatLngLit(directions.origin.coordinate),
                endLatLng: mapKitToGoogleLatLngLit(directions.destination.coordinate),
                term: mapoptions.poi,
                totalDistance: route.distance
            }));
        }
    }, [map, directions]);


    useEffect(() => {
        if (poiList.length > 0) {
            showPoiMarkers();
        }
    }, [poiList]); // When the list of Pois changes, then we show the markers


    const clickMarker = (poi) => {
        // use the react router
        const url = composePathPoi(adr1, adr2, poiname, travel, poi.result.id, mapoptions.code);
        navigate(url);
    }

    // show all POI Markers... they are already in the props
    const showPoiMarkers = () => {
        const mapkit = getMapKit();
        let pm: Array<any> = [];
        poiList.forEach(function (poi) {
            const latlng = getPoiLatLng(poi);
            const poiUrl = { 2: '/images/pins/' + poi.poiindex + ".png" };
            const coord = new mapkit.Coordinate(latlng.lat, latlng.lng);
            const pointItem = new mapkit.ImageAnnotation(coord, {
                url: poiUrl,
                enabled:true
            });
            pointItem.addEventListener('select', () => {
                clickMarker(poi);
            });
            pm.push(pointItem);
        });

        // show the new markers and the original start, end and route
        // This is fine because it won't re-add items already added.
        map.showItems([...dirObjects, ...pm]);
    }

    const isLoaded = mapkitstate.isLoaded && mapkitstate.isInitialized;

    const wrapclass = isLoaded ? "loaded mapkitmap" : "loading mapkitmap";

    return <div className={wrapclass}>
        <div className="map" ref={myRef}></div>
    </div>;
}

export default MapKitResults;
